import React, { useState, useEffect } from 'react';
import './Dashboard.css'; 
import Sidebar from './Sidebar';
import AddLoginModal from './AddLoginModal'; // Renamed modal
import userService from '../../api/userService'; // Use your user service

const LoginDetails = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  
  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [currentEditUser, setCurrentEditUser] = useState(null);
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  // User Data State
  const [userData, setUserData] = useState([]);

  // --- API LOGIC ---

  const fetchUsers = async () => {
  try {
    setLoading(true);
    // Changed from getAllUsers() to listUsers() to match service
    const response = await userService.listUsers();
    
    // Check if response has data property or is the array itself
    const data = response.data || response; 
    setUserData(Array.isArray(data) ? data : []); 
  } catch (error) {
    console.error("Failed to load users:", error);
  } finally {
    setLoading(false);
  }
};

// 2. CALL CREATE API
const handleCreateUser = async (formData) => {
  try {
    // Changed from register() to createUser() to match service
    await userService.createUser(formData); 
    await fetchUsers(); // Refresh list after creation
  } catch (error) {
    console.error("User creation failed:", error);
    throw error; // Re-throw so the Modal shows the error message
  }
};

// 3. CALL UPDATE API
const handleUpdateUser = async (formData) => {
  try {
    await userService.updateUser(formData);
    await fetchUsers();
  } catch (error) {
    console.error("Update failed:", error);
    throw error;
  }
};

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user login?")) {
      try {
        await userService.deleteUser(id);
        setUserData(prev => prev.filter(user => user._id !== id));
      } catch (error) {
        alert("Delete failed: " + error);
      }
    }
  };

  // --- UI LOGIC ---

  const filteredUsers = userData.filter(user => 
    user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredUsers.slice(firstIndex, lastIndex);
  const nPages = Math.ceil(filteredUsers.length / recordsPerPage);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const openAddModal = () => {
    setCurrentEditUser(null);
    setShowModal(true);
  };

  const openEditModal = (user) => {
    setCurrentEditUser(user);
    setShowModal(true);
  };

  return (
    <div className={`d-flex ${isToggled ? 'toggled' : ''}`} id="wrapper">
      <Sidebar />

      <div id="page-content-wrapper" className="bg-light flex-grow-1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom px-4 shadow-sm sticky-top">
          <div className="d-flex align-items-center w-100">
            <i className="bi bi-list fs-4 me-3 cursor-pointer" onClick={() => setIsToggled(!isToggled)}></i>
            <h5 className="mb-0 fw-bold">Management Panel</h5>
            <div className="ms-auto d-flex align-items-center">
                <span className="text-muted small fw-medium me-3">Admin / Login Details</span>
            </div>
          </div>
        </nav>

        <div className="container-fluid p-4">
          <div className="card border-0 shadow-sm" style={{ borderRadius: '15px', overflow: 'hidden' }}>
            
            <div className="card-header bg-white border-0 pt-4 px-4 pb-2">
              <div className="mb-3">
                <h6 className="fw-bold mb-0" style={{ color: '#1e293b', fontSize: '18px' }}>User Login Details</h6>
                <p className="text-muted mb-0" style={{ fontSize: '12.5px' }}>
                  {loading ? 'Syncing...' : `Total ${filteredUsers.length} accounts managed.`}
                </p>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="input-group shadow-sm" style={{ width: '350px', borderRadius: '10px', overflow: 'hidden' }}>
                  <span className="input-group-text bg-white border-end-0 px-3">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input 
                    type="text" 
                    className="form-control border-start-0 ps-1" 
                    placeholder="Search by name or email..." 
                    onChange={handleSearch}
                  />
                </div>

                <button className="btn btn-dark px-4 shadow-sm" onClick={openAddModal}>
                  <i className="bi bi-person-plus-fill me-2"></i> Add New Login
                </button>
              </div>
            </div>
            
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="text-muted text-uppercase" style={{ fontSize: '11px', fontWeight: '700' }}>
                      <th className="ps-4 py-3">S.No</th>
                      <th>User Info</th>
                      <th>Phone Number</th>
                      <th>Role</th>
                      <th>Account Status</th>
                      <th>Created Date</th>
                      <th className="text-end pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                       <tr><td colSpan="7" className="text-center py-5">Loading login data...</td></tr>
                    ) : currentRecords.length > 0 ? (
                      currentRecords.map((user, index) => (
                        <tr key={user._id}>
                          <td className="ps-4 text-muted">{firstIndex + index + 1}</td>
                          <td className="py-3">
                            <div className="d-flex align-items-center">
                              <img 
                                  src={`https://ui-avatars.com/api/?name=${user.name}&background=random`} 
                                  className="rounded-circle shadow-sm me-3" 
                                  width="40" height="40" alt="profile"
                                />
                              <div>
                                <div className="fw-bold" style={{ fontSize: '14px', color: '#1e293b' }}>{user.name}</div>
                                <small className="text-muted" style={{ fontSize: '11px' }}>{user.email}</small>
                              </div>
                            </div>
                          </td>
                          <td>{user.phoneNumber || 'N/A'}</td>
                          <td>
                            <span className={`badge ${user.role === 'admin' ? 'bg-primary' : 'bg-secondary'} fw-normal`}>
                              {user.role}
                            </span>
                          </td>
                          <td>
                            <span className={`badge rounded-pill ${user.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} px-3 py-2`}>
                              {user.isActive ? 'Active' : 'Suspended'}
                            </span>
                          </td>
                          <td className="text-muted small">
                             {new Date(user.createdAt).toLocaleDateString()}
                          </td>
                          <td className="text-end pe-4">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="btn btn-sm btn-light border" onClick={() => openEditModal(user)}>
                                <i className="bi bi-pencil-square text-primary"></i>
                              </button>
                              <button className="btn btn-sm btn-light border" onClick={() => handleDelete(user._id)}>
                                <i className="bi bi-trash3 text-danger"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="7" className="text-center py-5 text-muted">No users found.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
              <small className="text-muted">Page {currentPage} of {nPages || 1}</small>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
                  </li>
                  {[...Array(nPages)].map((_, i) => (
                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === nPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <AddLoginModal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        onAdd={handleCreateUser}
        onEdit={handleUpdateUser}
        onRefresh={fetchUsers} 
        editData={currentEditUser}
      />
    </div>
  );
};

export default LoginDetails;